<template>
	<header-menu-admin />

	<section class="error-section py-40" v-if="!category && !loading">
		<div class="container-fluid">
			<div class="error-wrapper text-center py-40 bg-white br-10">
				<h1 class="mb-32">404</h1>
				<h5 class="mb-16"><span class="color-primary">Упс!</span> Что-то пошло не так...</h5>
				<p class="light-gray mb-32">Категория товаров не найдена.<br/>Возможно она была удалена либо никогда не существовала.</p>
				<router-link :to="{path: '/admin/products-categories'}" class="cus-btn">В список категорий товаров</router-link>
			</div>
		</div>
	</section>
	
	<div v-else>
		<!-- Main Sections -->
		<main class="main-wrapper bg-lightest-gray">

			<!-- About Section Start -->
			<section class="about-section py-40">
				<div class="container-fluid">
					<div class="top-bar mb-16">
						<router-link :to="{path: '/admin/products-categories'}" class="btn btn-secondary">
							Назад
						</router-link>
					</div>
					<div class="about-wrapper bg-white">
						<div class="about-block">
							<h4 class="mb-12">Изменение категории товаров</h4>
							<form @submit.prevent="onProductsCategoryEdit" class="contact-form">
								<div class="row">
									<div class="col-md-1">
										<div class="input-block mb-16">
											<label for="id" class="form-label">ID записи:</label>
											<input type="number" id="id" class="form-control" :value="category?.id" disabled>
										</div>
									</div>
									<div class="col-md-1">
										<div class="input-block mb-16">
											<label for="parent_id" class="form-label">Родит. ID:</label>
											<input type="number" id="parent_id" @wheel="$event.target.blur()" class="form-control noscroll" min="1" v-model="parent_id">
										</div>
									</div>
									<div class="col-md-10">
										<div class="input-block mb-16">
											<label for="name" class="form-label">Название:</label>
											<input type="text" id="name" class="form-control" placeholder="Название" v-model="name" required>
										</div>
									</div>
									<div class="col-md-6">
										<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Сохранить изменения</button>
									</div>
									<div class="col-md-6 text-end">
										<button type="button" class="btn btn-outline-danger" @click="onDelete">Удалить</button>
									</div>
								</div>
							</form>
							<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
								{{error}}
								<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
							</div>
						</div>
					</div>
				</div>
			</section>
			<!-- About Section End -->
		</main>
		<!-- Main Sections -->
	</div>
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		category: null,
		parent_id: '',
		name: '',
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		async loadProductsCategory(){
			this.loading = true;
			this.appModel.preloader = true;
			
			const ret = await this.appModel.doGetProductsCategory(this.$route.params.id);
			if(ret.success){
				this.category = ret.item;
				this.parent_id = this.category?.parent_id||'';
				this.name = this.category?.name||'';
			}
			
			setTimeout(() => {
				this.loading = false;
				this.appModel.preloader = false;
			}, 1000);
		},
		async onProductsCategoryEdit(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				parent_id: this.parent_id,
				name: this.name,
			};
			let ret = await this.appModel.doEditProductsCategory(this.$route.params.id, params);
			this.btnDisabled = false;
			if(ret.success){
				ret = await this.appModel.doGetProductsCategories();
				if(ret.success) {
					this.appModel.productsCategories = ret.list;
				}
			} else {
				this.error = ret.error;
			}
		},
		async onDelete(){
			if(confirm('Вы уверены, что хотите удалить данную категорию товаров? Вместе с ней удалятся связанные с ней товары и кнопки на главной!')){
				let ret = await this.appModel.doDeleteProductsCategory(this.$route.params.id);
				if(ret.success){
					ret = await this.appModel.doGetProductsCategories();
					if(ret.success) {
						this.appModel.productsCategories = ret.list;
					}
					
					this.$router.push('/admin/products-categories');
				} else {
					alert(ret.error);
				}
			}
		},
	},
	async mounted(){
		window.scrollTo(0, 0);
		
		await this.loadProductsCategory();
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>